/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Hero_Cta_PrimaryInputs */

const en_cmp_hero_cta_primary = /** @type {(inputs: Cmp_Hero_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free`)
};

const id_cmp_hero_cta_primary = /** @type {(inputs: Cmp_Hero_Cta_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai gratis`)
};

/**
* | output |
* | --- |
* | "Start free" |
*
* @param {Cmp_Hero_Cta_PrimaryInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_hero_cta_primary = /** @type {((inputs?: Cmp_Hero_Cta_PrimaryInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Hero_Cta_PrimaryInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_hero_cta_primary(inputs)
	return en_cmp_hero_cta_primary(inputs)
});